import MuiSlider, { SliderProps as MuiSliderProps } from "@mui/material/Slider";
import styles from "./styles.module.css";

export type SliderProps = MuiSliderProps & {
  label?: string;
};

const Slider = ({ label, className, ...props }: SliderProps) => {
  return (
    <div className={styles.sliderWrapper}>
      {label && <span className={styles.sliderLabel}>{label}</span>}
      <MuiSlider
        valueLabelDisplay="auto"
        className={`${styles.slider} ${className ?? ""}`}
        {...props}
      />
    </div>
  );
};

export default Slider;
